<template>
    <div id="editor_noveloutline">
        <!-- 作品大纲 -->
        <div class="editor_noveloutline">
            <div class="editor_noveloutline_1">
                <div class="editor_noveloutline_2">作品大纲</div>
                <!-- v-if="editType !== 1" -->
                <div class="editor_noveloutline_3 cursor_1" @click="openTip">
                    <img src="../assets/image/icon_tip.png" alt="">
                    参考格式
                </div>
            </div>
            <textLoading v-if="streamStatus"></textLoading>
            <div class="cursor_1" v-if="!streamStatus && editType == 2" @click="changeOutline">换一换</div>
            <div class="editor_noveloutline_4">
                <div class="cursor_1 copyText t-m-r-10" @click="copyInnterText">复制内容</div>
                <div class="editor_noveloutline_5" v-if="aiCreateContent && noveloutline.length > 0">字数 {{ outlineNum +
                    aiCreateContent.length }}</div>
                <div class="editor_noveloutline_5" v-if="!aiCreateContent && noveloutline.length > 0">字数 {{ outlineNum
                }}</div>
                <div class="editor_noveloutline_5" v-if="aiCreateContent && !noveloutline.length">字数 {{
                    aiCreateContent.length }}</div>
            </div>

        </div>
        <div class="editor_noveloutline1" ref="editorOutline1" :class="isEditorMode ? '' : 'noEditor'">
            <!-- 编辑、ai续写、ai生成 控制按钮区域 -->
            <!-- <div class="checked" v-if="[2,3,4].includes(editType) && isEditorMode" :class="isEditorMode?'':'noClick'">
                  <el-checkbox v-model="checked">全选</el-checkbox>
            </div> -->
            <!-- 第一次的手写大纲 -->
            <div class="editor_noveloutline1_1" v-if="editType == 1" :class="isEditorMode ? '' : 'noClick'">
                <el-input type="textarea" show-word-limit :maxlength="200000" :placeholder="handPlaceholder"
                    @input="handInput" v-model="handText">
                </el-input>
            </div>
            <!-- 生成 -->
            <div class="editor_noveloutline1_2" v-if="editType == 2" :class="isEditorMode ? '' : 'noClick'">
                <editorOutlineList :is-edit="isEditorMode" :editType="editType" @del="delOutline"
                    :noveloutline="noveloutline" @getoutlineNum="getoutlineNum" @edit="openEdit"></editorOutlineList>
            </div>
            <!-- 编辑 -->
            <div class="editor_noveloutline1_2" v-if="editType == 3" :class="isEditorMode ? '' : 'noClick'">
                <editorOutlineList :is-edit="isEditorMode" :editType="editType" :noveloutline="noveloutline"
                    @getoutlineNum="getoutlineNum" @del="delOutline" @edit="openEdit"></editorOutlineList>
            </div>
            <!-- 续写章节 -->
            <div class="editor_noveloutline1_2" v-if="editType == 4" :class="isEditorMode ? '' : 'noClick'">
                <editorOutlineList :is-edit="isEditorMode" :editType="editType" :noveloutline="noveloutline"
                    @getoutlineNum="getoutlineNum" @del="delOutline" @edit="openEdit"></editorOutlineList>
            </div>
            <!-- 不用json方式，直接用打印机的方式显示 -->
            <div v-if="aiCreateContent" style="padding-top:15px;">
                <div style="white-space: pre-line">
                    {{ aiCreateContent }}
                </div>
            </div>
        </div>
        <div class="editor_noveloutline2">
            <!-- 这是添加大纲，手写、ai生成 -->
            <div v-if="[1, 2].includes(editType)" class="editor_noveloutline2_3">
                <div class="editor_noveloutline2_4 cursor_1 editor_noveloutline2_5" v-if="!isEditorMode"
                    @click="openEditor">编辑</div>
                <div class="editor_noveloutline2_4 cursor_1" v-else @click="save">提交</div>
                <el-button v-if="isEditorMode" type="warning" style="height: 38px;border-radius: 8px;" @click="next"
                    :loading="nextChapterLoading">
                    下一步:AI生成章纲
                </el-button>
                <div v-if="editType !== 2 && isEditorMode"
                    class="editor_noveloutline2_1 editor_noveloutline2_2 t-m-l-20">
                    <editorOutlineImport @parseOutline="parseOutline($event, 'insert')" />
                </div>
            </div>
            <!-- 这是编辑区域 -->
            <div v-else class="editor_noveloutline2_3">
                <div class="editor_noveloutline2_4 cursor_1 editor_noveloutline2_5" v-if="!isEditorMode"
                    @click="openEditor">编辑</div>
                <div class="editor_noveloutline2_4 cursor_1" v-else @click="save">提交</div>
                <div class="editor_noveloutline2_4 cursor_1 editor_noveloutline2_5"
                    v-if="isEditorMode && !hideEditorBtn" @click="handwriting('')">
                    手动续写大纲</div>
                <div class="editor_noveloutline2_4 cursor_1 editor_noveloutline2_5"
                    v-if="isEditorMode && !hideEditorBtn" @click="aiWriting">
                    AI续写大纲</div>
                <div v-if="isEditorMode && !hideEditorBtn"
                    class="editor_noveloutline2_4 cursor_1 editor_noveloutline2_5">
                    <editorOutlineImport @parseOutline="parseOutline($event, 'edit')" />
                </div>
            </div>
        </div>
        <!-- 停止生成按钮 -->
        <AIStopCreate :hide="streamStatus"></AIStopCreate>
        <!-- 参考格式弹框 -->
        <tipPopup ref="tipPopup"></tipPopup>
        <!-- 警告提示框 -->
        <warnPopup ref="warnPopup"></warnPopup>
        <!-- 续写大纲 -->
        <outlineContinuous ref="outlineContinuous" @getContinued="getContinued"></outlineContinuous>
        <!-- <delPopup @confirm="confirmOutline"></delPopup> -->
        <!-- 换一换要求 -->
        <textRequire ref="textRequire" placeholder="请输入你的要求（无要求可直接点立即生成哦）"></textRequire>
        <!-- 编辑 -->
        <editorChapterWrite ref="chapterWrite" @edit="editChapter" detection="章"></editorChapterWrite>
    </div>
</template>
<script>
import tipPopup from '@/components/tip_popup.vue'
import warnPopup from '@/components/warn_popup.vue'
import editorOutlineList from '@/components/editor_outlineList.vue'
import outlineContinuous from '@/components/outline_continuous.vue'
import editorOutlineImport from '@/components/editor_outline_import.vue'
import editorChapterWrite from '@/components/script/editor_chapter_write.vue'
import textRequire from '@/components/text_require.vue'// 要求
import { EventBus } from '@/utils/eventBus';
// import delPopup from './del_popup.vue';
import api from '@/api/api';
import textLoading from './text_loading.vue';
import { EncryptionUtil } from '@/utils/encrypt'
import { copy } from '@/utils/utils'
export default {
    components: {
        tipPopup, editorOutlineList, warnPopup, outlineContinuous, textLoading, textRequire, editorOutlineImport, editorChapterWrite
    },
    data() {
        return {
            editType: null, //1我有大纲手动输入 2Ai生成 3编辑大纲 4续写章节
            ifheadEdit: false, //  true表示手动输入如：我有大纲和手动续写；false表示ai生成、编辑、续写章节
            ifSave: false, //是否保存
            outlineNum: 0, //大纲字数
            // 手动输入提示词
            handPlaceholder: '请长按粘贴或者输入您的大纲:大纲格式请参考”官方动态-我有大纲格式标准”',
            handText: '',//手动输入内容
            noveloutline: [], //小说大纲
            outlineItem: '', //Ai生成大纲
            streamCapture: [-1, -1],
            // streamStatus: false, //流式请求
            // streamIndex: 0, //流式请求下标
            // debounceTimer: null, //防抖定时器
            textrequire: '',//作品要求
            isEditorMode: false, //false显示编辑 true显示保存
            isStop: false, //是否停止
            checked: false, //全选、反选
            isAiCreate: false,//是否ai去生成 true进入页面立即生成，false 表示不会刷新页面就生成
            hideEditorBtn: false,//false 默认不隐藏， true隐藏
        }
    },
    created() {
        //换一换，下一步都是这个去监听
        EventBus.$on('getRequire', (item) => {
            console.log('监听换一换的作品要求=', item);
            this.noveloutline = []
            this.textrequire = item
            //换一换 初始化取消ai生成的状态
            this.isStop = false
            this.isEditorMode = true
            this.createOutline()
        })
        let editItem = JSON.parse(sessionStorage.getItem('editItem'))
        console.log('大纲页面=', editItem)
        if (editItem) {
            this.editType = editItem.editType;
            this.isAiCreate = editItem.isAiCreate === true ? true : false;
            if (this.editType === 1) {
                this.ifheadEdit = true
                this.ifSave = false
                //我有大纲，进来可以先编辑
                this.isEditorMode = true
                this.openTip()
            } else if (this.editType === 2) {
                if (editItem.isAiCreate) {
                    //这里改变状态，如果重新刷新了页面就会提示
                    editItem.isAiCreate = false
                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                    this.ifheadEdit = false
                    //首次ai生成大纲，进来可以先编辑
                    this.isEditorMode = true
                    this.ifSave = false
                    this.createOutline()
                } else {
                    this.$notify({
                        title: '提示',
                        message: '请使用换一换来生成AI大纲',
                        duration: 5000,
                        type: 'warning'
                    });
                }

            } else if (this.editType === 3) {
                this.ifheadEdit = false
                this.getOutline()
            } else if (this.editType === 4) {
                this.getOutline()
                if (editItem.isAiCreate) {
                    //这里改变状态，如果重新刷新了页面就会提示
                    editItem.isAiCreate = false
                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                    //首次ai生成大纲，进来可以先编辑
                    this.isEditorMode = true
                    this.ifheadEdit = false
                    setTimeout(() => {
                        this.continuedWriting()
                    }, 0);
                } else {
                    this.isEditorMode = true
                    this.$notify({
                        title: '提示',
                        message: '请使用AI续写大纲进行续写',
                        duration: 5000,
                        type: 'warning'
                    });
                }
            }
        } else {
            // this.$message.warning('不支持多开页面进行操作')
            // setTimeout(() => {
            //     window.location.href = 'about:blank'; // 跳转到空白页
            // }, 500);

        }
    },
    beforeDestroy() {
        EventBus.$off('getRequire')
        this.clearTimer()
    },
    methods: {
        //销毁定时器
        clearTimer(status) {
            console.log('进来了销毁定时器')
            if (status) {
                this.isStop = true
                this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                this.parseToFormData()
            }
            this.mixinClearTimer()
            // this.streamCapture = [-1, -1]
            // this.outlineItem = ''
            // clearTimeout(this.debounceTimer)
            // this.streamStatus = false
            // this.streamIndex = 0
            // sessionStorage.removeItem('streamStatus');
        },
        parseToFormData() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            this.parseJSONToFormData(this.aiCreateContent, {
                params: {
                    isSkipEmpty: true,
                },
                ycCollback: (resultText) => {
                    let chapters = resultText.chapters.map(item => ({
                        name: item.title,
                        content: item.content
                    }))
                    if (this.noveloutline.length > 0) {
                        this.noveloutline.push(...chapters)
                    } else {
                        this.noveloutline = chapters
                    }
                    this.aiCreateContent = ''
                },
                wcCollback: () => {
                    this.$confirm('解析出错，请手动上传处理', '提示', {
                        confirmButtonText: '去处理',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        const content = this.aiCreateContent
                        this.aiCreateContent = ''
                        if (this.editType === 2) {
                            this.ifheadEdit = true
                            this.ifSave = false
                            this.handText = content
                            editItem.editType = 1
                            this.editType = 1
                            sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        } else if ([3, 4].includes(this.editType)) {
                            this.handwriting(content)
                        }

                    }).catch(() => {
                        this.$message.info('已取消手动处理');
                        this.aiCreateContent = ''
                    });
                }
            })
        },
        //打开格式提示
        openTip() {
            this.$nextTick(() => {
                this.$refs.tipPopup.openPopup();
            })

        },
        //监听输入框变化
        handInput() {
            sessionStorage.setItem('ifEditor', true)
            this.outlineNum = this.handText.length
        },
        //换一换ai生成
        changeOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            this.$refs.textRequire.openPrompt(editItem?.novelInfo.length.includes('短') ? 'i_short_outline' : 'i_medium_outline', '')
        },
        //Ai生成大纲 和 换一换
        createOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                novelName: editItem.novelInfo.name,
                label: editItem.novelInfo.labels,
                style: editItem.novelInfo.typeName,
                chapter: editItem.novelInfo.chaptersNumber,
                content: editItem.novelInfo.introduction,
                novelId: editItem.novelInfo.id,
                platform: 1,
                requirement: this.textrequire ? this.textrequire : ''
            }
            this.AIWrite({
                length: '中',
                haveId: true,
                type: editItem?.novelInfo.length.includes('短') ? 'i_short_outline' : 'i_medium_outline',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    sessionStorage.setItem('ifEditor', true)
                    this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
                    localStorage.setItem('AICreateId', res.data)
                    // this.getStreamContent(res.data)
                    this.getComStreamContent(res.data, {
                        scrollRef: this.scrollRef,
                        success: () => {
                            this.parseToFormData()
                        }
                    })
                },
                warn: (res) => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                }
            })

            // api.novelHelpWriteId(editItem?.novelInfo.length.includes('短') ? 'short_outline' : 'medium_outline',
            //     {
            //         novelName: editItem.novelInfo.name,
            //         label: editItem.novelInfo.labels,
            //         style: editItem.novelInfo.typeName,
            //         chapter: editItem.novelInfo.chaptersNumber,
            //         content: editItem.novelInfo.introduction,
            //         novelId: editItem.novelInfo.id,
            //         platform: 1,
            //         requirement: this.textrequire ? this.textrequire : ''
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         sessionStorage.setItem('ifEditor', true)
            //         this.hideEditorBtn = true //ai生成完成隐藏编辑里面的按钮
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.streamStatus = false
            //         sessionStorage.removeItem('streamStatus');
            //         this.$message.warning(res.msg)
            //     }
            // }).catch(() => {
            //     this.streamStatus = false
            //     sessionStorage.removeItem('streamStatus');
            // })
        },
        //章节列表 下面的 续写章节
        continuedWriting() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let data = {
                plot: editItem.plot,
                chapter: editItem.chapter,
                novelId: editItem.novelInfo.id,
            }
            this.ifheadEdit = false
            EventBus.$emit('handwriting', false, '')
            this.getContinued(data)
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    this.outlineItem += item
                                    this.streamCapture[0] = this.outlineItem.indexOf('{');
                                    this.streamCapture[1] = this.outlineItem.indexOf('}');

                                    if (this.streamCapture[0] !== -1 && this.streamCapture[1] !== -1) {
                                        const jsonStr = this.outlineItem.substring(this.streamCapture[0], this.streamCapture[1] + 1)
                                        this.outlineItem = this.outlineItem.replace(jsonStr, '')
                                        let chapterObj = this.escapeControlCharacters(jsonStr)
                                        const chapter = JSON.parse(chapterObj);
                                        let obj = {
                                            name: chapter.title,
                                            content: chapter.plot
                                        }
                                        this.noveloutline.push(obj);
                                        this.scrollToBottom(); // 调用滚动方法
                                        this.streamCapture = [-1, -1]
                                    }
                                }
                            });
                            if (res.data[res.data.length - 1] === '[DONE]') {
                                this.streamIndex = 0
                                //刷新用户信息-基础会员字符刷新
                                this.getUserInfo()
                                this.clearTimer()
                                return
                            }
                            this.getStreamContent(id)
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.streamStatus = false
                });
            }, 500);
        },
        escapeControlCharacters(str) {
            // eslint-disable-next-line no-control-regex
            return str.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
        },
        // 滚动到内容底部
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.editorOutline1;
                if (container) {
                    container.scrollTop = container.scrollHeight; // 设置滚动位置到底部
                }
            });
        },
        //获取大纲内容
        getOutline() {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            api.getChapterList(editItem.id).then((res) => {
                if (res.code == 200) {
                    this.totle = res.totle
                    this.noveloutline = res.data
                    //如果是续写篇章先让内容滚动到最下面，然后生成的时候进行拼接
                    if (this.editType === 4) {
                        this.scrollToBottom()
                    }
                }
            })

        },
        //获取大纲字数
        getoutlineNum(item) {
            console.log('编辑里的手写内容=', item)
            this.outlineNum = item.num
            this.noveloutline = item.list
            if (item.handText) {
                this.handText = item.handText
            }
        },
        //手动续写
        handwriting(content = '') {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            if (!content) {
                this.handText = ''
            }
            this.$refs.tipPopup.openPopup();
            this.ifheadEdit = true
            this.hideEditorBtn = true
            EventBus.$emit('handwriting', true, content)
        },
        //AI续写
        aiWriting() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.$refs.outlineContinuous.openPopup();
            this.ifheadEdit = false
            EventBus.$emit('handwriting', false, '')
        },
        //打开编辑
        openEditor() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            sessionStorage.setItem('ifEditor', true)
            this.isEditorMode = true
            this.ifSave = false
        },
        //修改
        openEdit(data) {
            this.$refs.chapterWrite.editInfo({ ...data.item, indexNum: data.index, topName: '编辑大纲' })
        },
        //大纲导入
        parseOutline(content, type) {
            console.log('type=', type)
            //第一次手写添加的内容
            if (type === 'insert') {
                this.handText = content
            } else if (type === 'edit') {
                //编辑里的手动续写
                this.handText = content
                // console.log('content=', content)
                this.handwriting(content)
            }
            this.handInput()
        },
        //获取续写大纲
        getContinued(continued) {
            let editItem = JSON.parse(sessionStorage.getItem('editItem'))
            let params = {
                plot: continued.plot,
                chapter: continued.chapter,
                novelId: editItem.novelInfo.id,
            }
            this.AIWrite({
                length: '中',
                haveId: true,
                type: editItem?.novelInfo.length.includes('短') ? 'i_short_outline_continue' : 'i_medium_outline_continue',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    sessionStorage.setItem('streamStatus', this.streamStatus)
                    this.hideEditorBtn = true
                    localStorage.setItem('AICreateId', res.data)
                    // this.getStreamContent(res.data)
                    this.getComStreamContent(res.data, {
                        scrollRef: this.scrollRef,
                        success: () => {
                            this.parseToFormData()
                        }
                    })
                },
                warn: (res) => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                    this.$message.warning(res.msg)
                },
                error: () => {
                    this.streamStatus = false
                    sessionStorage.removeItem('streamStatus');
                }
            })
            // api.novelHelpWriteId(editItem?.novelInfo.length.includes('短') ? 'short_outline_continue' : 'medium_outline_continue',
            //     {
            //         plot: continued.plot,
            //         chapter: continued.chapter,
            //         novelId: editItem.novelInfo.id,
            //     }
            // ).then((res) => {
            //     if (res.code == 200) {
            //         // console.log(res)
            //         this.streamStatus = true
            //         sessionStorage.setItem('streamStatus', this.streamStatus)
            //         this.hideEditorBtn = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.streamStatus = false
            //         sessionStorage.removeItem('streamStatus');
            //         this.$message.warning(res.msg)
            //     }
            // }).catch(() => {
            //     this.streamStatus = false
            //     sessionStorage.removeItem('streamStatus');
            // })
        },
        //下一步生成章纲
        next() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            if (this.noveloutline.length || this.handText.trim()) {
                this.nextChapterLoading = true
                let editItem = JSON.parse(sessionStorage.getItem('editItem'))
                //提交大纲内容
                this.confirmOutline(true, () => {
                    //进行下一步章纲操作
                    let chapterList = []
                    api.getChapterList1(editItem.id, 1).then((res) => {
                        if (res.code == 200) {
                            chapterList = res.rows
                            if (!res.rows.length) {
                                this.$message.warning('请先保存后在进行下一步生成章纲操作')
                                return
                            }
                            editItem = {
                                id: editItem.id,
                                novelInfo: editItem.novelInfo,
                                editText: 3,
                                chapter: chapterList[0].number,
                                chapterId: chapterList[0].id,
                                chapterName: chapterList[0].name,
                                textId: chapterList[0].textId,
                            };
                            sessionStorage.setItem('editItem', JSON.stringify(editItem));
                            this.nextChapterLoading = false
                            window.location.reload()
                        }
                    })
                })

            } else {
                this.$notify({
                    title: '提示',
                    message: `没有大纲内容`,
                    // duration: 0,
                    type: 'warning'
                });
            }
        },
        //保存大纲
        confirmOutline(isNextChapter, callback) {
            const editItem = JSON.parse(sessionStorage.getItem('editItem'));
            //我有大纲、手动续写
            if (this.ifheadEdit) {
                if (!this.handText.trim()) {
                    EventBus.$emit('handwriting', false, '')
                    sessionStorage.removeItem('streamStatus');
                    sessionStorage.setItem('ifEditor', false)
                    //保存大纲后，不可编辑
                    this.isEditorMode = false
                    this.hideEditorBtn = false
                    return
                }
                api.handNovelOutline({
                    id: editItem.id,
                    text: this.handText
                }).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('大纲保存成功！');
                        editItem.backNum = 1
                        if (this.editType === 1) {
                            //如果执行下一步生成章纲，反之直接跳到短剧小说列表页面
                            if (isNextChapter) {
                                callback && callback()
                            } else {
                                this.$confirm('大纲内容提交成功，是否前去导入章节正文?', '提示', {
                                    confirmButtonText: '去导入',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    console.log('editItem.novelInfo=', editItem.novelInfo)
                                    let novelInfo = EncryptionUtil.encrypt(editItem.novelInfo)
                                    this.$router.replace({
                                        path: '/chapterUpdate', query: {
                                            novelId: editItem.id,
                                            pageNum: 1,
                                            pageSize: 10,
                                            novelInfo
                                        }
                                    });
                                }).catch(() => {
                                    let edit = {
                                        id: editItem.id,
                                        editText: 1,
                                        editType: 3,
                                        novelInfo: editItem.novelInfo
                                    }
                                    sessionStorage.setItem('editItem', JSON.stringify(edit))
                                    this.$router.replace({ path: '/novel' })
                                });

                            }
                            return
                        }
                        //手写保存后，变成可以编辑的api
                        this.ifheadEdit = false
                        this.ifSave = true
                        //保存大纲后，不可编辑
                        this.isEditorMode = false
                        //保存后可以出现手动续写和ai编辑
                        this.isStop = false
                        //ai生成完成隐藏编辑里面的按钮
                        this.hideEditorBtn = false
                        editItem.editType = 3
                        sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        EventBus.$emit('handwriting', false, '')
                        sessionStorage.removeItem('streamStatus');
                        sessionStorage.setItem('ifEditor', false)
                        if ([1, 2].includes(this.editType)) {
                            window.location.reload()
                        } else {
                            this.getOutline()
                        }
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            } else {
                //'编辑、ai生成、续写大纲'
                if (!this.noveloutline.length) {
                    this.isEditorMode = false
                    return
                }
                const outline = {
                    outlineContent: '',
                    // chaptersName: [],
                    // numbers: [],
                    // content: '',
                    // chaptersId: [],
                    outlineChaptersNameVos: []
                };

                // 遍历 noveloutline 数组，填充大纲对象
                this.noveloutline.forEach((item, i) => {
                    console.log('item=', item);
                    outline.outlineContent += item.name + item.content;
                    // outline.chaptersName.push(item.name);
                    // outline.content += `content:${item.content}`;
                    // outline.numbers.push(i + 1);
                    // outline.chaptersId.push(item.id);
                    outline.outlineChaptersNameVos.push({
                        name: item.name,
                        content: item.content,
                        number: i + 1,
                        id: item.id || '-1'
                    })
                });

                // 构建通用参数
                const baseParams = {
                    novelId: editItem.novelInfo.id,
                    // chapter: editItem.novelInfo.chaptersNumber,
                    // novelName: editItem.novelInfo.name,
                    // label: editItem.novelInfo.labels,
                    // style: editItem.novelInfo.typeName,
                    outlineContent: outline.outlineContent,
                    outlineChaptersNameVos: outline.outlineChaptersNameVos,
                    requirement: this.textrequire || '',
                    // chaptersName: outline.chaptersName.join(','),
                    // numbers: outline.numbers.join(','),
                    // content: outline.content
                };

                // 根据 editType 决定是否添加额外参数
                const params = {
                    ...baseParams,
                    // ...(editItem.editType === 3 ? {
                    //     number: this.noveloutline.length,
                    //     chaptersId: outline.chaptersId.map(item => item === undefined ? '-1' : item).join(',')
                    // } : editItem.editType === 2 ? {} : {})
                };
                //保存大纲
                api.saveNovelOutline(params).then((res) => {
                    if (res.code === 200) {
                        editItem.backNum = 1
                        if (this.editType === 2) {
                            //如果执行下一步生成章纲，反之直接跳到短剧小说列表页面
                            if (isNextChapter) {
                                callback && callback()
                            } else {
                                this.$confirm('大纲内容提交成功，是否前去导入章节正文?', '提示', {
                                    confirmButtonText: '去导入',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    console.log('editItem.novelInfo=', editItem.novelInfo)
                                    let novelInfo = EncryptionUtil.encrypt(editItem.novelInfo)
                                    this.$router.replace({
                                        path: '/chapterUpdate', query: {
                                            novelId: editItem.id,
                                            pageNum: 1,
                                            pageSize: 10,
                                            novelInfo
                                        }
                                    });
                                }).catch(() => {
                                    sessionStorage.setItem('editItem', JSON.stringify(editItem))
                                    this.$router.replace({ path: '/novel' })
                                });

                            }
                            return
                        }
                        this.$message.success(res.msg);
                        this.ifSave = true
                        //保存大纲后，不可编辑
                        this.isEditorMode = false
                        //保存后可以出现手动续写和ai编辑
                        this.isStop = false
                        //ai生成完成隐藏编辑里面的按钮
                        this.hideEditorBtn = false
                        editItem.editType = 3
                        sessionStorage.setItem('editItem', JSON.stringify(editItem))
                        sessionStorage.removeItem('streamStatus');
                        sessionStorage.setItem('ifEditor', false)
                        if ([1, 2].includes(this.editType)) {
                            window.location.reload()
                        } else {
                            this.getOutline()
                        }
                    } else {
                        this.$message.warning(res.msg)
                    }
                });
            }
        },
        // 保存大纲
        save() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            if (this.editType === 1 && !this.handText.trim()) {
                this.$notify({
                    title: '提示',
                    message: `没有大纲内容`,
                    // duration: 0,
                    type: 'warning'
                });
                return
            }
            if ([2, 3, 4].includes(this.editType) && !this.noveloutline.length) {
                this.$notify({
                    title: '提示',
                    message: `没有大纲内容`,
                    // duration: 0,
                    type: 'warning'
                });
                return
            }
            if (this.isStop) {
                this.cancelAi().then(() => {
                    this.confirmOutline()
                })
            } else {
                this.confirmOutline()
            }
        },
        //删除大纲
        delOutline(data) {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = ''
            if (data.index === this.noveloutline.length - 1) {
                text = `是否需要删除从第${data.index + 1}章，删除后无法恢复，请慎重操作`
            } else {
                text = `是否需要删除从第${data.index + 1}章到后面所有的章节，删除后对应的章节和正文都会删除，且无法恢复，请慎重操作`
            }
            this.$confirm(text, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //如果当前有id说明是已经存在的，如果没有id说明是刚ai生成的
                // console.log('data=', data)
                if (data.id !== -1) {
                    api.delNovelOutline({ id: data.id }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('删除成功')
                            this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                            this.novleEmptyIsToPath()
                        }
                    })
                } else {
                    this.noveloutline = this.noveloutline.filter((_, i) => i < data.index) // 从当前索引开始删除所有后续元素
                    this.$message.success('删除成功')
                    this.novleEmptyIsToPath()
                }
            })
        },
        //如果删除后没有内容就跳转到入口页面
        novleEmptyIsToPath() {
            if (!this.noveloutline.length) {
                let editItem = JSON.parse(sessionStorage.getItem('editItem'));
                console.log('editItem=', editItem)
                editItem.backNum = 2
                editItem.editText = ''
                sessionStorage.setItem('editItem', JSON.stringify(editItem));
                this.$router.replace('/novel')
            }
        },
        //item 续写有内容，没有则是编辑后需要刷新
        editChapter(item) {
            console.log(item)
            if (item) {
                this.isEditorMode = true
                if (this.noveloutline.some((s, si) => si === item.indexNum)) {
                    this.noveloutline = this.noveloutline.map((f, i) => {
                        //如果存在就替换
                        if (i === item.indexNum) {
                            console.log('编辑')
                            delete item.indexNum
                            f = item
                        }
                        return f
                    })
                }
                // this.scrollToBottom()
            }
        },
        // 复制正文
        async copyInnterText() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完成！');
                return
            }
            let text = ''
            if ([1].includes(this.editType)) {
                text = this.handText
            } else if ([2, 3, 4].includes(this.editType)) {
                text = this.noveloutline.reduce((count, item) => {
                    return count + '\n' + item.name + '\n' + item.content
                }, '')
                text += '\n' + this.clearText(this.handText)
            }
            const success = await copy(text);
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
    }
}
</script>

<style lang="scss">
#editor_noveloutline {
    width: 100%;
    height: 100%;
    background-color: #FFF;
    position: relative;
}

.editor_noveloutline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    height: 67px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_noveloutline_1 {
    display: flex;
    align-items: center;
}

.editor_noveloutline_2 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    margin-right: 10px;

}

.editor_noveloutline_3 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #333333;
}

.editor_noveloutline_3 img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.editor_noveloutline_4 {
    display: flex;
    align-items: center;
}

.editor_noveloutline_5 {
    font-size: 15px;
    color: #444444;
}

.editor_noveloutline_6 {
    font-size: 15px;
    color: var(--tech-primary);
    margin-left: 20px;
}

.editor_noveloutline1 {
    height: calc(100% - 138px);
    overflow-y: auto;
    padding: 25px 40px;
    position: relative;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover();
    }
}

.editor_noveloutline1_1 {
    height: 100%;
}

.editor_noveloutline1_1 .el-textarea {
    height: 100%;
}

.editor_noveloutline1_1 .el-textarea .el-textarea__inner {
    height: 100%;
}

.editor_noveloutline1 .el-textarea__inner {
    width: 100%;
    min-height: 100px;
    background-color: transparent;
    border: none;
    resize: none;
    outline: none;
    box-shadow: none;
    padding: 0;
}

.editor_noveloutline2 {
    height: 69px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_noveloutline2_1 {
    padding: 10px 15px;
    background: #AAAAAA;
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
}

.editor_noveloutline2_2 {
    background: var(--tech-primary);
}

.editor_noveloutline2_3 {
    display: flex;
}

.editor_noveloutline2_4 {
    width: 167px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    border-radius: 8px;
    border: 1px solid var(--tech-primary);
    font-size: 17px;
    color: var(--tech-primary);
    cursor: pointer;
    margin-right: 20px;
}

.editor_noveloutline2_5 {
    background-color: var(--tech-primary);
    color: #FFFFFF;
    border: none;
}

.editor_noveloutline2_4:last-child {
    margin-right: 0;
}

.checked {
    position: absolute;
    right: 20px;
    top: 5px;
    z-index: 99;
}

.copyText {
    height: 36px;
    padding: 0 10px;
    line-height: 36px;
    text-align: center;
    border-radius: 8px;
    /* background-color: var(--tech-primary); */
    /* color: #fff; */
    /* border: 1px solid var(--tech-primary); */
    color: var(--tech-primary);
    font-size: 15px;
    cursor: pointer;
}
</style>